import styled from 'styled-components'
import { IconLeftRotate } from '@edulastic/icons'

export const RightRotateIconContainer = styled.div`
  position: absolute;
  bottom: -6px;
  left: -1px;
`
export const LeftRotateIconContainer = styled.div`
  position: absolute;
  right: -1px;
  top: -1px;
`
export const ProtractorLeftRotateIconContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 5px;
`
export const TransformedLeftRotateIcon = styled(IconLeftRotate)`
  transform: rotate(90deg);
`
export const RulerCrossButtonContainer = styled.div`
  position: absolute;
  top: 40%;
  left: 25px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #e43334;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`
export const ProtractorCrossButtonContainer = styled.div`
  position: absolute;
  bottom: 25px;
  right: 18%;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #e43334;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`
